import { Link } from "react-router-dom";
import imgsuper1 from "../assets/supervivencia1.jpeg";
import imgsuper2 from "../assets/supervivencia2.jpeg";
import imgsuper3 from "../assets/supervivencia3.jpeg";
import imgsuper4 from "../assets/supervivencia4.jpeg";
import logofundacion1 from "../assets/logofundacion1.png";
import ReactWhatsapp from "react-whatsapp";
import React, { useEffect, useState } from "react";
import fondo from "../assets/fondo6.png";

export default function Supervivencia() {
  const imagenes = [imgsuper1, imgsuper2,imgsuper3,imgsuper4];

  const [indiceImagen, setIndiceImagen] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setIndiceImagen((prev) => (prev + 1) % imagenes.length);
    }, 3000);

    return () => clearInterval(intervalo);
  }, [imagenes.length]);

  return (
    <div className=" min-h-screen text-white flex flex-col">
      
      {/* Encabezado con botón de regreso */}
      <header className="bg-white text-green-two p-1 flex justify-between items-center">
        <div className="h-full">
          <img
            src={logofundacion1}
            alt="Logo Fundación Manitas de colores"
            className="pt-2 rounded-2xl mx-auto md:h-18 h-20"
          />
        </div>

        <h1 className="text-2xl font-bold hidden lg:block">
          Supervivencia
        </h1>

        <Link
          to="/"
          className="bg-orange-one hover:bg-orange-600 text-white px-2 py-2 rounded"
        >
          ← Volver al inicio
        </Link>
      </header>

      {/* Contenido principal */}
      <main className="flex-1 p-8">
        <div
          name="quehacemos"
          className="w-full  bg-cover bg-center relative"
          style={{
            backgroundImage: `url(${fondo})`,
          }}
        >
          <div className="max-w-screen-lg px-4 mx-auto flex flex-col md:flex-row items-center md:justify-center w-full h-full gap-8 pt-4 md:pt-10">
            
            {/* TEXTO */}
            <div className="w-full md:w-1/2">
              <p className="text-2xl sm:text-4xl md:text-4xl lg:text-4xl xl:text-4xl font-bold text-orange-one">
                Los primeros meses de vida son fundamentales para el desarrollo integral de cada niño.              </p>

              <p className="text-1xl sm:text-2xl mt-6 text-green-one">
                <strong>Grupo objetivo:</strong> Madres gestantes y bebés de 0
                a 12 meses
              </p>

              <p className="text-1xl sm:text-2xl mt-6 text-green-one">
                <strong>
                Porque ayudar:</strong> Con tu aporte, madres y bebés reciben acompañamiento, nutrición, desarrollo y oportunidades para crecer.                
              </p>

              {/* BOTÓN CENTRADO */}
              <div className="mt-4 flex justify-center">
                <ReactWhatsapp
                  number="+59162211995"
                  message="Saludos, necesito Información sobre la Fundación Manitas de Colores"
                  element="text"
                >
                  <button className="bg-orange-one hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full shadow-md">
                    Contáctanos
                  </button>
                </ReactWhatsapp>
              </div>
            </div>

            {/* IMAGEN */}
            <div className="w-full md:w-1/2 flex justify-center">
              <img
                src={imagenes[indiceImagen]}
                alt={`Grupo Supervivencia ${indiceImagen + 1}`}
                className="rounded-xl object-cover w-full max-w-md h-[280px] sm:h-[340px] md:h-[420px] lg:h-[480px] shadow-lg"              />
            </div>

          </div>
        </div>
      </main>
    </div>
  );
}